export default __webpack_public_path__ + "static/media/devopss.ed2370b9.png";